module.exports = __webpack_public_path__ + "img/rona_1kl.cfec6abe.jpg";